import { Outlet, Link } from 'react-router-dom'
import { ArrowLeftIcon, LogOutIcon } from '@nimbus-ds/icons'
import { Text } from '@nimbus-ds/components'
import { useAuth } from '@/hooks/useAuth'
import { authService } from '@/api/auth'

/**
 * Lean, mobile-first shell for the merchant "standup" view. Deliberately NOT the
 * consultant Layout (no sidebar, no dense nav) — a merchant checks this on their
 * phone between serving customers. One header, one column.
 */
export function MerchantLayout() {
  const { user, logout } = useAuth()
  // Consultants/admins reach this view to preview what a merchant sees — give
  // them a way back to the console. Actual merchants don't see this.
  const isPreview = !authService.isMerchant()
  return (
    <div className="min-h-screen bg-muted/20">
      <header className="sticky top-0 z-10 border-b bg-background/95 backdrop-blur">
        <div className="mx-auto flex max-w-xl items-center justify-between px-4 py-3">
          <div className="flex min-w-0 items-center gap-3">
            {isPreview && (
              <Link to="/dashboard" className="text-muted-foreground hover:text-foreground" aria-label="Volver al panel">
                <ArrowLeftIcon size={20} />
              </Link>
            )}
            <div className="min-w-0">
              <div className="truncate">
                <Text fontWeight="bold" color="neutral-textHigh">{user?.store_name || 'Tu tienda'}</Text>
              </div>
              <Text fontSize="caption">{isPreview ? 'Vista comerciante (previsualización)' : 'Resumen diario'}</Text>
            </div>
          </div>
          <button onClick={logout} className="text-muted-foreground hover:text-foreground" aria-label="Salir">
            <LogOutIcon size={20} />
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-xl px-4 py-5">
        <Outlet />
      </main>
    </div>
  )
}
